import { Button } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

export const SeeSimilarPosts: React.FC<{ tagId: string }> = ({ tagId }) => {
  return (
    <NextLink href={`/community/tags/${tagId}`}>
      <Button>Explore Similar Posts</Button>
    </NextLink>
  );
};
